"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProgressBarProps = void 0;
const react_redux_1 = require("react-redux");
const question_1 = require("src/utils/question");
const useProgressBarProps = () => (0, react_redux_1.useSelector)((state) => {
    var _a;
    // @ts-expect-error TS(2339): Property 'pages' does not exist on type 'DefaultRo... Remove this comment to see the full error message
    const { pages, questions } = state;
    const { currentPage, list } = pages;
    let completed = 0;
    const countQuestions = questions && Object.keys(questions).length;
    if (!countQuestions) {
        return {
            percent: 0,
            totalPages: 0,
            currentPageNumber: 0,
        };
    }
    // Если страницы закончили
    if (currentPage === -1) {
        return {
            percent: 100,
            totalPages: list.length,
            currentPageNumber: currentPage + 1,
        };
    }
    for (let i = 0; i < currentPage; i++) {
        completed += list[i].questionIds.length;
    }
    list[currentPage].questionIds.forEach((questionId) => {
        const question = (0, question_1.getQuestionModel)(questions, questionId);
        const value = question.getValueAsObj();
        if (value.text || (value.options && value.options.length > 0)) {
            completed++;
        }
    });
    return {
        percent: (_a = Math.floor((completed / countQuestions) * 100)) !== null && _a !== void 0 ? _a : 0,
        totalPages: list.length,
        currentPageNumber: currentPage + 1,
    };
});
exports.useProgressBarProps = useProgressBarProps;
